import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  constructor(private _restService: RestService, private router: Router) {}

  isSuperUser: any = "";
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";
  mergedArray: any = [];
  count: any = 0;

  ngOnInit() {
    this.isSuperUser = localStorage.getItem("isSuper");
    let arrayValues: any = [];
    this._restService
      .getUserNotification()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("fm", f.mergedArr),
          f.mergedArr.filter((f: any, index: any) =>
            index <= 2 ? this.mergedArray.push(f) : ""
          ),
          this.mergedArray.length > 0
            ? this.mergedArray.filter((f: any) =>
                f.hasOwnProperty("jobId")
                  ? f.eventType === 1
                    ? ((f.type = "Job removed by user"), (f.name = "job"))
                    : f.eventType === 2
                    ? ((f.type = "Job configured"), (f.name = "job"))
                    : f.eventType === 3
                    ? ((f.type = "Job edited"), (f.name = "job"))
                    : f.eventType === 4
                    ? ((f.type = "New job added"), (f.name = "job"))
                    : f.eventType === 5
                    ? ((f.type = "Job refresh"), (f.name = "job"))
                    : f.eventType === 6
                    ? ((f.type = "Job not configured"), (f.name = "job"))
                    : ""
                  : f.hasOwnProperty("machineId")
                  ? f.eventType === 1
                    ? ((f.type = "Machine removed by user"),
                      (f.name = "machine"))
                    : f.eventType === 2
                    ? ((f.type = "Machine configured"), (f.name = "machine"))
                    : f.eventType === 3
                    ? ((f.type = "Machine edited"), (f.name = "machine"))
                    : f.eventType === 4
                    ? ((f.type = "New machine added"), (f.name = "machine"))
                    : f.eventType === 5
                    ? ((f.type = "Machine refresh"), (f.name = "machine"))
                    : f.eventType === 6
                    ? ((f.type = "Machine not configured"),
                      (f.name = "machine"))
                    : ""
                  : ""
              )
            : "",
          f.mergedArr.length > 0
            ? f.mergedArr.filter((f: any) =>
                f.hasOwnProperty("FlaggedNotfiyId")
                  ? f.flaggedType === 1
                    ? ((f.type = "Conflict with maintenance"),
                      (f.name = "flagged"))
                    : f.flaggedType === 2
                    ? ((f.type = "Deployment failed"), (f.name = "flagged"))
                    : f.flaggedType === 3
                    ? ((f.type = "Bot access lost"), (f.name = "flagged"))
                    : f.flaggedType === 4
                    ? ((f.type = "Machine Access lost"), (f.name = "flagged"))
                    : f.flaggedType === 5
                    ? ((f.type = "AA  Credentials Invalid"),
                      (f.name = "flagged"))
                    : f.flaggedType === 6
                    ? ((f.type = "Bot system access removed"),
                      (f.name = "flagged"))
                    : f.flaggedType === 7
                    ? ((f.type = "Machine system access removed"),
                      (f.name = "flagged"))
                    : ""
                  : ""
              )
            : "",
          f.mergedArr.length > 0
            ? f.mergedArr.filter((f: any) =>
                f.hasOwnProperty("systemId")
                  ? f.eventType === 1
                    ? ((f.type = "New system created"), (f.name = "system"))
                    : f.eventType === 2
                    ? ((f.type = "System deleted"), (f.name = "system"))
                    : f.eventType === 3
                    ? ((f.type = "System enabled"), (f.name = "system"))
                    : f.eventType === 4
                    ? ((f.type = "System disabled"), (f.name = "system"))
                    : f.eventType === 5
                    ? ((f.type = "System edited"), (f.name = "system"))
                    : ""
                  : ""
              )
            : "",
          f.mergedArr.map((f: any) =>
            f.hasOwnProperty("jobId")
              ? f.eventType !== 5
                ? arrayValues.push(f)
                : ""
              : f.hasOwnProperty("machineId")
              ? f.eventType !== 5
                ? arrayValues.push(f)
                : ""
              : f.hasOwnProperty("FlaggedNotfiyId")
              ? arrayValues.push(f)
              : f.hasOwnProperty("systemId")
              ? arrayValues.push(f)
              : ""
          ),
          (this.count = f.mergedArr.length),
          (this.isLoading = false)
        )
      );
  }

  logout() {
    this._restService.callingLogout().subscribe((f: any) => console.log(f));
    localStorage.clear();
    this.router.navigate([""]);
  }

  notificationEvent() {
    this.router.navigate(["notification"]);
  }
}
